import * as HLF from "html-living-framework";
import {Application} from "../Application";
import {Anchor} from "../core/Anchor";
import {Ease} from "../core/Animatable";
import {Container} from "../core/Container";
import {Callback} from "../core/Reflection";
import {Circle} from "../core/Shape";
import {Sprite} from "../core/Sprite";
import {Assets} from "../data/Assets";
import {CharacterType} from "../data/CharacterType";
import {StoryInjection} from "../data/StoryModel";
import {VoiceOverManager} from "../managers/VoiceOverManager";
import {StoryCreator} from "../states/StoryCreator";
import {Characters} from "./Character";

export const SceneInjectionCharacterReactionOptions = {
    inFrame: true,
};

export class SceneInjectionCharacterReaction implements StoryInjection {

    private assets?: Array<HLF.IAsset<any>>;
    private readonly characterType: CharacterType;
    private readonly vo: string | string[];
    private readonly isLong: boolean;

    constructor(characterType: CharacterType, vo: string | string[], isLong: boolean = false) {
        this.characterType = characterType;
        this.vo = vo;
        this.isLong = isLong;
    }

    public execute(storyCreator: StoryCreator, cb: Callback): void {
        if (Application.instance.audio.masterVolume === 0) {
            cb();
            return;
        }
        if (SceneInjectionCharacterReactionOptions.inFrame) {

            const container = storyCreator.scene!.topContainer.addChild(new Container());
            const frame = container.addChild(new Sprite("reaction-frame", Anchor.middleCenter));
            const character = container.addChild(new (Characters[this.characterType])());
            frame.scale.set(1.9);
            container.x = frame.width * 0.55;
            container.y = 1536 - frame.height * 0.55;
            character.scale.set(0.18);
            character.y = this.characterType === CharacterType.Xavier ? 280 : 260;
            character.x = 5;
            character.mask = container.addChild(new Circle(frame.width * 0.48));
            container.moveYFrom(container.y + frame.height * 1.1, 0.4, Ease.backOut, () => {
                VoiceOverManager.instance.playVO(this.vo, () => {
                    if (this.isLong) {
                        container.moveYTo(container.y + frame.height * 1.1, 0.2, Ease.sineIn, () => {
                            container.destroy();
                            cb();
                        });
                    } else {
                        character.delayedCall(0.8, () => {
                            container.moveYTo(container.y + frame.height * 1.1, 0.2, Ease.sineIn, () => {
                                container.destroy();
                            });
                        });
                        cb();
                    }
                });
            });

        } else {

            const character = storyCreator.scene!.topContainer.addChild(new (Characters[this.characterType])());
            character.x = 220;
            character.y = 1660;
            character.scale.set(0.26);
            character.moveYFrom(character.y + character.height, 0.2, Ease.sineOut, () => {
                VoiceOverManager.instance.playVO(this.vo, () => {
                    if (this.isLong) {
                        character.moveYTo(character.y + character.height, 0.2, Ease.sineIn, () => {
                            character.destroy();
                            cb();
                        });
                    } else {
                        character.delayedCall(0.8, () => {
                            character.moveYTo(character.y + character.height, 0.2, Ease.sineIn, () => {
                                character.destroy();
                            });
                        });
                        cb();
                    }
                });
            });
        }
    }

    public getAssets(): Array<HLF.IAsset<any>> {
        if (!this.assets) {
            this.assets = [
                Assets.characters[this.characterType],
                ...((typeof this.vo === "string") ? [this.vo] : this.vo).map((it) => new HLF.AudioAsset(it, HLF.AudioCategory.VO)),
            ];
        }
        return this.assets;
    }
}
